const getPatinationProps = pagination => {
  return pagination === null
    ? null
    : {
        onChange: () => {},
        currentPage: 1,
        totalPages: 1,
        ...pagination,
      };
};

export default getPatinationProps;
